export const squareColors = {
  RED: "red",
  GREEN: "green",
  BLUE: "blue",
  YELLOW: "yellow",
  GRAY: "gray",
};

export const startingHandSquares = [
  [
    { name: "AA", color: squareColors.BLUE, active: true },
    { name: "AKs", color: squareColors.YELLOW, active: true },
    { name: "AQs", color: squareColors.YELLOW, active: true },
    { name: "AJs", color: squareColors.YELLOW, active: true },
    { name: "ATs", color: squareColors.YELLOW, active: true },
    { name: "A9s", color: squareColors.YELLOW, active: true },
    { name: "A8s", color: squareColors.YELLOW, active: true },
    { name: "A7s", color: squareColors.YELLOW, active: true },
    { name: "A6s", color: squareColors.YELLOW, active: true },
    { name: "A5s", color: squareColors.YELLOW, active: true },
    { name: "A4s", color: squareColors.YELLOW, active: true },
    { name: "A3s", color: squareColors.YELLOW, active: true },
    { name: "A2s", color: squareColors.YELLOW, active: true },
  ],

  [
    { name: "AKo", color: squareColors.RED, active: true },
    { name: "KK", color: squareColors.BLUE, active: true },
    { name: "KQs", color: squareColors.YELLOW, active: true },
    { name: "KJs", color: squareColors.YELLOW, active: true },
    { name: "KTs", color: squareColors.YELLOW, active: true },
    { name: "K9s", color: squareColors.YELLOW, active: true },
    { name: "K8s", color: squareColors.YELLOW, active: true },
    { name: "K7s", color: squareColors.YELLOW, active: true },
    { name: "K6s", color: squareColors.YELLOW, active: false },
    { name: "K5s", color: squareColors.YELLOW, active: false },
    { name: "K4s", color: squareColors.YELLOW, active: false },
    { name: "K3s", color: squareColors.YELLOW, active: false },
    { name: "K2s", color: squareColors.YELLOW, active: false },
  ],

  [
    { name: "AQo", color: squareColors.RED, active: true },
    { name: "KQo", color: squareColors.RED, active: true },
    { name: "QQ", color: squareColors.BLUE, active: true },
    { name: "QJs", color: squareColors.YELLOW, active: true },
    { name: "QTs", color: squareColors.YELLOW, active: true },
    { name: "Q9s", color: squareColors.YELLOW, active: true },
    { name: "Q8s", color: squareColors.YELLOW, active: false },
    { name: "Q7s", color: squareColors.YELLOW, active: false },
    { name: "Q6s", color: squareColors.YELLOW, active: false },
    { name: "Q5s", color: squareColors.YELLOW, active: false },
    { name: "Q4s", color: squareColors.YELLOW, active: false },
    { name: "Q3s", color: squareColors.YELLOW, active: false },
    { name: "Q2s", color: squareColors.YELLOW, active: false },
  ],

  [
    { name: "AJo", color: squareColors.RED, active: true },
    { name: "KJo", color: squareColors.RED, active: true },
    { name: "QJo", color: squareColors.RED, active: true },
    { name: "JJ", color: squareColors.BLUE, active: true },
    { name: "JTs", color: squareColors.YELLOW, active: true },
    { name: "J9s", color: squareColors.YELLOW, active: true },
    { name: "J8s", color: squareColors.YELLOW, active: false },
    { name: "J7s", color: squareColors.YELLOW, active: false },
    { name: "J6s", color: squareColors.YELLOW, active: false },
    { name: "J5s", color: squareColors.YELLOW, active: false },
    { name: "J4s", color: squareColors.YELLOW, active: false },
    { name: "J3s", color: squareColors.YELLOW, active: false },
    { name: "J2s", color: squareColors.YELLOW, active: false },
  ],

  [
    { name: "ATo", color: squareColors.RED, active: true },
    { name: "KTo", color: squareColors.RED, active: true },
    { name: "QTo", color: squareColors.RED, active: true },
    { name: "JTo", color: squareColors.RED, active: true },
    { name: "TT", color: squareColors.BLUE, active: true },
    { name: "T9s", color: squareColors.YELLOW, active: true },
    { name: "T8s", color: squareColors.YELLOW, active: true },
    { name: "T7s", color: squareColors.YELLOW, active: false },
    { name: "T6s", color: squareColors.YELLOW, active: false },
    { name: "T5s", color: squareColors.YELLOW, active: false },
    { name: "T4s", color: squareColors.YELLOW, active: false },
    { name: "T3s", color: squareColors.YELLOW, active: false },
    { name: "T2s", color: squareColors.YELLOW, active: false },
  ],

  [
    { name: "A9o", color: squareColors.RED, active: true },
    { name: "K9o", color: squareColors.RED, active: true },
    { name: "Q9o", color: squareColors.RED, active: true },
    { name: "J9o", color: squareColors.RED, active: true },
    { name: "T9o", color: squareColors.RED, active: true },
    { name: "99", color: squareColors.BLUE, active: true },
    { name: "98s", color: squareColors.YELLOW, active: true },
    { name: "97s", color: squareColors.YELLOW, active: true },
    { name: "96s", color: squareColors.YELLOW, active: false },
    { name: "95s", color: squareColors.YELLOW, active: false },
    { name: "94s", color: squareColors.YELLOW, active: false },
    { name: "93s", color: squareColors.YELLOW, active: false },
    { name: "92s", color: squareColors.YELLOW, active: false },
  ],

  [
    { name: "A8o", color: squareColors.RED, active: true },
    { name: "K8o", color: squareColors.RED, active: false },
    { name: "Q8o", color: squareColors.RED, active: false },
    { name: "J8o", color: squareColors.RED, active: false },
    { name: "T8o", color: squareColors.RED, active: false },
    { name: "98o", color: squareColors.RED, active: false },
    { name: "88", color: squareColors.BLUE, active: true },
    { name: "87s", color: squareColors.YELLOW, active: true },
    { name: "86s", color: squareColors.YELLOW, active: true },
    { name: "85s", color: squareColors.YELLOW, active: false },
    { name: "84s", color: squareColors.YELLOW, active: false },
    { name: "83s", color: squareColors.YELLOW, active: false },
    { name: "82s", color: squareColors.YELLOW, active: false },
  ],

  [
    { name: "A7o", color: squareColors.RED, active: false },
    { name: "K7o", color: squareColors.RED, active: false },
    { name: "Q7o", color: squareColors.RED, active: false },
    { name: "J7o", color: squareColors.RED, active: false },
    { name: "T7o", color: squareColors.RED, active: false },
    { name: "97o", color: squareColors.RED, active: false },
    { name: "87o", color: squareColors.RED, active: false },
    { name: "77", color: squareColors.BLUE, active: true },
    { name: "76s", color: squareColors.YELLOW, active: true },
    { name: "75s", color: squareColors.YELLOW, active: true },
    { name: "74s", color: squareColors.YELLOW, active: false },
    { name: "73s", color: squareColors.YELLOW, active: false },
    { name: "72s", color: squareColors.YELLOW, active: false },
  ],

  [
    { name: "A6o", color: squareColors.RED, active: false },
    { name: "K6o", color: squareColors.RED, active: false },
    { name: "Q6o", color: squareColors.RED, active: false },
    { name: "J6o", color: squareColors.RED, active: false },
    { name: "T6o", color: squareColors.RED, active: false },
    { name: "96o", color: squareColors.RED, active: false },
    { name: "86o", color: squareColors.RED, active: false },
    { name: "76o", color: squareColors.RED, active: false },
    { name: "66", color: squareColors.BLUE, active: true },
    { name: "65s", color: squareColors.YELLOW, active: true },
    { name: "64s", color: squareColors.YELLOW, active: true },
    { name: "63s", color: squareColors.YELLOW, active: false },
    { name: "62s", color: squareColors.YELLOW, active: false },
  ],

  [
    { name: "A5o", color: squareColors.RED, active: false },
    { name: "K5o", color: squareColors.RED, active: false },
    { name: "Q5o", color: squareColors.RED, active: false },
    { name: "J5o", color: squareColors.RED, active: false },
    { name: "T5o", color: squareColors.RED, active: false },
    { name: "95o", color: squareColors.RED, active: false },
    { name: "85o", color: squareColors.RED, active: false },
    { name: "75o", color: squareColors.RED, active: false },
    { name: "65o", color: squareColors.RED, active: false },
    { name: "55", color: squareColors.BLUE, active: true },
    { name: "54s", color: squareColors.YELLOW, active: true },
    { name: "53s", color: squareColors.YELLOW, active: false },
    { name: "52s", color: squareColors.YELLOW, active: false },
  ],

  [
    { name: "A4o", color: squareColors.RED, active: false },
    { name: "K4o", color: squareColors.RED, active: false },
    { name: "Q4o", color: squareColors.RED, active: false },
    { name: "J4o", color: squareColors.RED, active: false },
    { name: "T4o", color: squareColors.RED, active: false },
    { name: "94o", color: squareColors.RED, active: false },
    { name: "84o", color: squareColors.RED, active: false },
    { name: "74o", color: squareColors.RED, active: false },
    { name: "64o", color: squareColors.RED, active: false },
    { name: "54o", color: squareColors.RED, active: false },
    { name: "44", color: squareColors.BLUE, active: true },
    { name: "43s", color: squareColors.YELLOW, active: false },
    { name: "42s", color: squareColors.YELLOW, active: false },
  ],

  [
    { name: "A3o", color: squareColors.RED, active: false },
    { name: "K3o", color: squareColors.RED, active: false },
    { name: "Q3o", color: squareColors.RED, active: false },
    { name: "J3o", color: squareColors.RED, active: false },
    { name: "T3o", color: squareColors.RED, active: false },
    { name: "93o", color: squareColors.RED, active: false },
    { name: "83o", color: squareColors.RED, active: false },
    { name: "73o", color: squareColors.RED, active: false },
    { name: "63o", color: squareColors.RED, active: false },
    { name: "53o", color: squareColors.RED, active: false },
    { name: "43o", color: squareColors.RED, active: false },
    { name: "33", color: squareColors.BLUE, active: true },
    { name: "32s", color: squareColors.YELLOW, active: false },
  ],

  [
    { name: "A2o", color: squareColors.RED, active: false },
    { name: "K2o", color: squareColors.RED, active: false },
    { name: "Q2o", color: squareColors.RED, active: false },
    { name: "J2o", color: squareColors.RED, active: false },
    { name: "T2o", color: squareColors.RED, active: false },
    { name: "92o", color: squareColors.RED, active: false },
    { name: "82o", color: squareColors.RED, active: false },
    { name: "72o", color: squareColors.RED, active: false },
    { name: "62o", color: squareColors.RED, active: false },
    { name: "52o", color: squareColors.RED, active: false },
    { name: "42o", color: squareColors.RED, active: false },
    { name: "32o", color: squareColors.RED, active: false },
    { name: "22", color: squareColors.BLUE, active: true },
  ],
];

export const boardSquares = [
  [
    { name: "Ah", color: squareColors.RED, active: false },
    { name: "Ac", color: squareColors.GREEN, active: false },
    { name: "Ad", color: squareColors.BLUE, active: true },
    { name: "As", color: squareColors.GRAY, active: false },
  ],

  [
    { name: "Kh", color: squareColors.RED, active: false },
    { name: "Kc", color: squareColors.GREEN, active: false },
    { name: "Kd", color: squareColors.BLUE, active: false },
    { name: "Ks", color: squareColors.GRAY, active: false },
  ],

  [
    { name: "Qh", color: squareColors.RED, active: false },
    { name: "Qc", color: squareColors.GREEN, active: false },
    { name: "Qd", color: squareColors.BLUE, active: false },
    { name: "Qs", color: squareColors.GRAY, active: false },
  ],

  [
    { name: "Jh", color: squareColors.RED, active: false },
    { name: "Jc", color: squareColors.GREEN, active: false },
    { name: "Jd", color: squareColors.BLUE, active: false },
    { name: "Js", color: squareColors.GRAY, active: true },
  ],

  [
    { name: "Th", color: squareColors.RED, active: false },
    { name: "Tc", color: squareColors.GREEN, active: false },
    { name: "Td", color: squareColors.BLUE, active: false },
    { name: "Ts", color: squareColors.GRAY, active: false },
  ],

  [
    { name: "9h", color: squareColors.RED, active: true },
    { name: "9c", color: squareColors.GREEN, active: false },
    { name: "9d", color: squareColors.BLUE, active: false },
    { name: "9s", color: squareColors.GRAY, active: false },
  ],

  [
    { name: "8h", color: squareColors.RED, active: false },
    { name: "8c", color: squareColors.GREEN, active: false },
    { name: "8d", color: squareColors.BLUE, active: false },
    { name: "8s", color: squareColors.GRAY, active: false },
  ],

  [
    { name: "7h", color: squareColors.RED, active: false },
    { name: "7c", color: squareColors.GREEN, active: false },
    { name: "7d", color: squareColors.BLUE, active: false },
    { name: "7s", color: squareColors.GRAY, active: false },
  ],

  [
    { name: "6h", color: squareColors.RED, active: false },
    { name: "6c", color: squareColors.GREEN, active: false },
    { name: "6d", color: squareColors.BLUE, active: false },
    { name: "6s", color: squareColors.GRAY, active: false },
  ],

  [
    { name: "5h", color: squareColors.RED, active: false },
    { name: "5c", color: squareColors.GREEN, active: false },
    { name: "5d", color: squareColors.BLUE, active: false },
    { name: "5s", color: squareColors.GRAY, active: false },
  ],

  [
    { name: "4h", color: squareColors.RED, active: false },
    { name: "4c", color: squareColors.GREEN, active: false },
    { name: "4d", color: squareColors.BLUE, active: false },
    { name: "4s", color: squareColors.GRAY, active: false },
  ],

  [
    { name: "3h", color: squareColors.RED, active: false },
    { name: "3c", color: squareColors.GREEN, active: true },
    { name: "3d", color: squareColors.BLUE, active: false },
    { name: "3s", color: squareColors.GRAY, active: false },
  ],

  [
    { name: "2h", color: squareColors.RED, active: false },
    { name: "2c", color: squareColors.GREEN, active: false },
    { name: "2d", color: squareColors.BLUE, active: false },
    { name: "2s", color: squareColors.GRAY, active: false },
  ],
];

export const statisticsDataUpper = [
  { name: "Straight", value: 13.2 },
  { name: "Set", value: 9.39 },
  { name: "Two pair", value: 15.2 },
  { name: "Top pair", value: 3.79 },
  { name: "PP below tp", value: 7.91 },
  { name: "Middle pair", value: 29.7 },
  { name: "Weak pair", value: 0 },
  { name: "No made hand", value: 20.9 },
];

export const statisticsDataLower = [
  { name: "Flush draw", value: 12.8 },
  { name: "No flush draw", value: 87.2 },
  { name: "Oesd", value: 14.2 },
  { name: "Gutshot", value: 32.9 },
];
